module.exports = __webpack_public_path__ + "static/media/preplay-interruption-icon.5f5d1f5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-interruption-icon.svg
// module id = ./src/assets/images/preplay-interruption-icon.svg
// module chunks = 0